<template>
  <div class="d-flex align-items-center">
    <div class="mr-4">
      <strong class="mb-0">{{ $t('global.variable') }}:</strong>
    </div>
    <multiselect
      @select="onMappingRuleSelect"
      class="mapping-rule-multiselect my-4"
      :placeholder="$t('global.select')"
      v-model="selectedMappingRule"
      :allow-empty="false"
      :deselect-label="''"
      :options="mappingRules"
      :searchable="false"
      :select-label="''"
      :selected-label="''"
      :value="selectedMappingRule.columnName">
      <template slot="singleLabel" slot-scope="props">
        <span class="option__title d-flex align-items-center justify-content-between w-100 py-0">
          <span v-if="!props.option.custom" class="bg-purple px-5">{{ props.option.fromLabel }}</span>
          <span v-else class="bg-purple px-5">{{ props.option.from }}</span>
          <span class="text-center bg-gray-light">{{ $t('feeds.used_in_field') }}</span>
          <span class="bg-orange-light px-5">{{ props.option.to }}</span>
        </span>
      </template>
      <template slot="option" slot-scope="props">
        <span class="option__title d-flex align-items-center justify-content-between w-100 py-0">
          <span v-if="!props.option.custom" class="bg-purple px-5">{{ props.option.fromLabel }}</span>
          <span v-else class="bg-purple px-5">{{ props.option.from }}</span>
          <span class="text-center bg-gray-light">{{ $t('feeds.used_in_field') }}</span>
          <span class="bg-orange-light px-5">{{ props.option.to }}</span>
        </span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SourceVariable',

  data () {
    return {
      selectedMappingRule: {}
    }
  },

  props: {
    mappingRule: { required: false, type: Object },
    mappingRules: { required: true, type: Array }
  },

  created () {
    if (this.mappingRule !== undefined) this.selectedMappingRule = this.mappingRule
  },

  methods: {
    onMappingRuleSelect (mappingRule) {
      this.$emit('onMappingRuleSelect', mappingRule)
    }
  },

  components: { Multiselect }
}
</script>
